import { Box } from "@mui/material";
import { keyframes, styled } from "@mui/material/styles";
import React from "react";

interface LoaderVideoProps {
  cardSize: number;
}

const l11Animation0 = keyframes({
  "0%": {
    transform: "translate(-40%) rotate(0) translate(0) rotate(0)",
  },
  "25%": {
    transform: "translate(40%) rotate(0) translate(0) rotate(0)",
  },
  "50%": {
    transform: "translate(40%) rotate(180deg) translate(0) rotate(0)",
  },
  "75%": {
    transform: "translate(40%) rotate(180deg) translate(80%) rotate(0)",
  },
  "100%": {
    transform: "translate(40%) rotate(180deg) translate(80%) rotate(180deg)",
  },
});

const l11Animation1 = keyframes({
  "0%, 25%, 50%, 75%, 100%": {
    transform: "translate(0)",
  },
  "12.5%, 62.5%": {
    transform: "translate(var(--s, 20%))",
  },
});

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize",
})<LoaderVideoProps>(({ cardSize }) => ({
  position: "relative",
  width: `${cardSize / 4}px`,
  height: `${cardSize / 4}px`,
  borderRadius: "9999px",
  overflow: "hidden",
  border: `${cardSize * 0.01}px solid white`,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const Loader = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize",
})<LoaderVideoProps>(({ cardSize }) => ({
  height: `${cardSize / 8}px`,
  aspectRatio: ".866",
  display: "grid",
  background:
    "conic-gradient(from -121deg at right, #0000, rgba(255, 255, 255, 0.33) 1deg 60deg, #0000 61deg)",
  animation: `${l11Animation0} 2s infinite`,
  transformOrigin: "33% 50%",
  position: "absolute",
  transform: "translate(-50%, -50%) rotate(-45deg)",
  marginRight: "-12.5%",
  "::before": {
    content: '""',
    gridArea: "1 / 1",
    background:
      "conic-gradient(from -121deg at right, #0000, rgba(255, 255, 255, 0.66) 1deg 60deg, #0000 61deg)",
    animation: `${l11Animation1} 2s infinite`,
  },
  "::after": {
    content: '""',
    gridArea: "1 / 1",
    background:
      "conic-gradient(from -121deg at right, #0000, white 1deg 60deg, #0000 61deg)",
    animation: `${l11Animation1} 2s infinite`,
    "--s": "50%",
  },
}));

export const LoaderVideo: React.FC<LoaderVideoProps> = ({ cardSize }) => {
  return (
    <Container cardSize={cardSize}>
      <Loader cardSize={cardSize} />
    </Container>
  );
};
